export interface UserCustomer {
  customerId?: string;
  customerStatusId?: number;
  customerName?: string;
  contactId: string;
  statusId?: number;
  contactPostcode?: string;
  contactPhone?: string;
}
